import { ApiRoutes } from "consts/enpoints/api";
import { fetchApi } from "infrastructure/api";
import type { PaymentMethod } from "./types";
import { HttpVerb } from "consts/api";

export const getPaymentMethods = (queryParams = '') =>
    fetchApi(`${ApiRoutes.GetPaymentMethods()}${queryParams}`);

export const getMerchantVisibleMethods = (queryParams = '') =>
    fetchApi(`${ApiRoutes.GetMerchantVisibleMethods()}${queryParams}`);

export const getPotentialPaymentMethods = (queryParams = '') =>
    fetchApi(`${ApiRoutes.GetPotentialPaymentMethods()}${queryParams}`);

export const postMerchantVisibleMethods = (body: Pick<PaymentMethod, 'tag'>) =>
    fetchApi(ApiRoutes.PostMerchantVisibleMethods(), {
        method: HttpVerb.Post,
        body
    });

export const deleteMerchantVisibleMethods = ({ coreId }: Pick<PaymentMethod, 'coreId'>) =>
    fetchApi(ApiRoutes.DeleteMerchantVisibleMethods(coreId), {
        method: HttpVerb.Delete
    });
